import { ISidebarContent } from '../../gui/progress-sidebar/progress-sidebar.component';

export interface IZimWizNavItem extends ISidebarContent {
  button?: {
    text: 'next' | 'confirm';
    action: 'next' | 'complete';
  };
}

export const NavItemsConfig: IZimWizNavItem[] = [
  {
    header: 'Pattern Configurations',
    id: 0,
    button: {
      text: 'next',
      action: 'next',
    },
  },
  {
    header: 'Hardware Configurations',
    id: 1,
    button: {
      text: 'next',
      action: 'next',
    },
  },
  {
    header: 'Software Configurations',
    id: 2,
    button: {
      text: 'next',
      action: 'next',
    },
  },
  {
    header: 'Summary',
    id: 3,
    button: {
      text: 'confirm',
      action: 'complete',
    },
  },
];
